import { WorkflowIDocCoreErrorDTO } from 'src/app/shared/interfaces/workflows/workflow-idoc-core-error-dto.interface';
import { MailDetailsTakeOverDto } from '../../mails/mail-details-dto.';
import { LastStatusTransition } from '../scans/last-status-transition';
import { MailDestinataireBaseContactInput } from './mail-destinataire-base-contact-input';
import { EmailSender } from '../email/email-sender';

export class MailInsert {
  public id?: number;
  public serviceProprietaireId: number;
  public typeEntrantSortant: string;
  public natureId?: number;
  public sourceId?: number;
  public refExpediteur?: string;
  public expediteurLibre?: string;
  public expediteurId?: number;
  public expediteurIdiAdmin?: number;
  public MailUniqueId?: number;

  public objet?: string;
  public remarques?: string;
  public dateDocument?: string;
  public dateEcheance?: string;
  public dateEntree?: string;
  public classementId?: number;
  public classeurId?: number;
  public chemiseId?: number;
  public dossierId?: number;
  public refRecommande?: string;
  public projetId?: number;
  public confidentiel?: boolean;
  public datePostale?: string;
  public boiteArchive?: string;
  public statutId?: number;
  public autoDistributionbUsers?: MailDestinataireBaseContactInput[];
  public autoDistributionServices?: number[];
  public lastStatusTransition?: LastStatusTransition;
  public statusGlobalName?: string;
  public statusGlobalColor?: string;
  public statusGlobalBackground?: string;
  public workflowStartError: WorkflowIDocCoreErrorDTO;
  public workflowStartFailed: boolean;
  public workflowId: string;
  public workflowStartId: string;
  public workflowStartDefinitionId: string;
  public version?;
  public natureCustomDatas = [];
  public classementLabel?: string;
  public classeurLabel?: string;
  public chemiseLabel?: string;
  public bacLabelForInfos?: string;
  public bacId?;
  public workflowForInfos?;
  public Files?;
  public priseEnChargeInfo?: MailDetailsTakeOverDto;
  public sender: EmailSender;
  public aCompleter?: boolean;

  public mauvaisRoutage?: boolean;
  constructor(data?) {
    Object.assign(this, data);
  }
}
